
import { z } from "zod";

// Constants for file validation
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ACCEPTED_FILE_TYPES = ["application/pdf", "image/png", "image/jpeg", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

// Form validation schema
export const contactFormSchema = z.object({
  name: z.string().min(2, {
    message: "Name must be at least 2 characters.",
  }),
  company: z.string().optional(),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  phone: z.string().optional(),
  source: z.string({
    required_error: "Please select how you found me.",
  }),
  message: z.string().min(10, {
    message: "Message must be at least 10 characters.",
  }),
  attachmentUrl: z.string().optional(),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
